 <!--<ci-icon 
    name="more-landscape" 
    type="svg"
    scale="2x"
    (click)="handleMoreClick()"
  ></ci-icon>-->
  
  <ci-button 
    class="more-button"
    class-name="ci-btn-primary-s-outlined" 
    type="button" 
    icon-name="email" 
    (click)="handleMoreClick()"
    [attr.aria-label]="'Enviar ruta' | translate"
    tabindex="0"
  >
    {{ 'Enviar ruta' | translate }}
  </ci-button>